module.exports = __webpack_public_path__ + "img/ski_place10.bbdc75a9.png";